module.exports = __webpack_public_path__ + "img/circle4red.81019015.png";